import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DeviceClassName, pluralize } from '@iotv/datamodel-core';
import { AppValueTypes } from '@iotv/iotv-v3-types';
import { Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { ShowDefinedEntriesOnlyOpts } from '../../../types/AppTypes';
import { ObjectDetailCard } from '../../../v2/components/generic/ObjectView/ObjectDetailCard';
import { getGatewayDevices } from '../../DeviceManagement/tabs/Wideawake/GatewayDevices';
import { getViewDefintionFromObject } from '../../factories/AttributeDefinitions';
import { SimpleList } from '../../factories/Listerlizer/SimpleList';
const GatewayViewDefinition = {
    lastDeviceSeen: {
        key: 'lastDeviceSeen',
        label: 'Last Device Seen',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    isAWOL: {
        key: 'isAWOL',
        type: AppValueTypes.BOOLEAN,
        label: 'Is AWOL',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    lastAWOL: {
        key: 'lastAWOL',
        label: 'Last AWOL',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    AWOLHistory: {
        key: 'AWOLHistory',
        label: 'History of AWOL',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    primaryGatewayUplinkCount: {
        key: 'primaryGatewayUplinkCount',
        label: 'Total Uplinks Received',
        type: AppValueTypes.NUMBER,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
};
export const getAppropriateDevice = async (gateway) => {
    return await getGatewayDevices({ sourceNode: gateway, ExclusiveStartKey: undefined, Limit: 200 });
};
const GatewayAssociationTab = (props) => {
    const { gateway, userFunctions, transactionFunctions } = props;
    const [deviceList, setDeviceList] = useState([]);
    useEffect(() => {
        getAppropriateDevice(gateway).then((devList) => setDeviceList(devList));
    }, [gateway.sk]);
    const { name, eui, deviceType, lastSeen } = getViewDefintionFromObject({ type: DeviceClassName });
    const viewDefinition = { name, eui, deviceType, lastSeen };
    return (_jsxs(Stack, { gap: 1, children: [_jsxs("div", { children: [_jsx(Typography, { variant: "h6", children: "Performance" }), _jsx(ObjectDetailCard, { matchedPrimary: gateway, viewDefinition: GatewayViewDefinition, definedEntriesOnlyOpt: ShowDefinedEntriesOnlyOpts.Yes, showContextSubCard: false, userFunctions: userFunctions, transactionFunctions: transactionFunctions })] }), _jsxs("div", { children: [_jsxs(Typography, { variant: "h6", children: [`${deviceList.length}`, " Linked ", pluralize('Device', deviceList.length)] }), _jsx(SimpleList, { listItems: deviceList, viewDefinition: viewDefinition })] })] }));
};
export default GatewayAssociationTab;
